

































































import { Component, Mixins, Ref } from "vue-property-decorator";
import VDataTable from "@monade/vue-components/src/components/VDataTable.vue";
import Paginator from "@monade/vue-components/src/components/VPaginator.vue";
import UsersMixin, {
  CREATE_USER,
  GET_USERS,
  UPDATE_USER,
} from "@/mixins/http/UsersMixin";
import { RegisterHttp } from "@/utils/Decorators";
import RequestData from "@/store/types/RequestData";
import UserModal from "@/components/Admin/UserModal.vue";
import ConfirmDeletion from "@/components/Admin/ConfirmDeletion.vue";
import { User } from "@/models";
import VIcon from "@/components/VIcon.vue";
interface ColumnData {
  sortable?: boolean;
  sort?: string;
  name?: string;
  class?: string;
  default?: string;
  label?: string;
}

@Component({
  components: { VDataTable, Paginator, UserModal, ConfirmDeletion, VIcon },
})
export default class Users extends Mixins(UsersMixin) {
  items: User[] = [];
  loading = false;
  page = 1;

  @Ref() readonly userModal!: UserModal;
  @Ref() readonly confirmDeletion!: ConfirmDeletion;

  @RegisterHttp(GET_USERS)
  request?: RequestData;

  @RegisterHttp(CREATE_USER)
  postRequest?: RequestData;

  async mounted() {
    await this.loadData();
  }

  get meta() {
    return this.request?.meta;
  }

  get columns() {
    const columns: ColumnData[] = [];
    this.pushColumnInAllScreens(columns, { name: "name", label: "Nome" });
    this.pushColumnInAllScreens(columns, { name: "email", label: "Email" });
    this.pushColumnInAllScreens(columns, { name: "role", label: "Ruolo" });
    this.pushColumnInAllScreens(columns, { name: "isActive", label: "Stato" });
    this.pushColumnInAllScreens(columns, { name: "action", label: "" });

    return columns;
  }

  private pushColumnInAllScreens(columns: ColumnData[], column: ColumnData) {
    columns.push(column);
  }

  async loadData() {
    this.loading = true;
    this.items = await this.getUsers({ page: this.page });
    this.loading = false;
  }

  async onPageChange(page: number) {
    this.page = page;
    await this.loadData();
  }

  onCreateUser() {
    this.userModal.open(null, CREATE_USER);
  }

  onEditUser(value: User) {
    this.userModal.open(value, UPDATE_USER);
  }

  onDeleteUser(value: User) {
    this.confirmDeletion.open(value.id);
  }

  async onConfirmDeletion(id: string) {
    try {
      await this.destroyUser(id);
    } finally {
      await this.loadData();
    }
  }

  async onUserChanged(user: User) {
    try {
      if (user.id) {
        await this.updateUser(user);
      } else {
        await this.createUser(user);
      }
      this.userModal.close();
      this.loadData();
    } catch (e) {
      this.loadData();
    }
  }
}
